import { apiClient } from "./apiClient";

export const calendarService = {
  // --- External Calendar Integrations ---

  async connectExternal(payload) {
    // payload: { workspaceId, provider, username, password, serverUrl, settings }
    return apiClient("/calendar/external/connect", {
      method: "POST",
      body: payload
    });
  },

  async syncExternal(configId) {
    return apiClient(`/calendar/external/sync/${configId}`, {
      method: "POST"
    });
  },

  async getConnectedCalendars() {
    return apiClient(`/calendar/external`, {
      method: "GET"
    });
  },

  async disconnectCalendar(configId) {
    return apiClient(`/calendar/external/${configId}`, {
      method: "DELETE"
    });
  },

  // --- Internal Calendar CRUD ---

  async getEvents(workspaceId, startDate, endDate) {
    let url = `/calendar/workspace/${workspaceId}`;
    if (startDate && endDate) {
      url += `?startDate=${startDate}&endDate=${endDate}`;
    }
    return apiClient(url, {
      method: "GET"
    });
  },

  async createEvent(eventData) {
    return apiClient("/calendar", {
      method: "POST",
      body: eventData
    });
  },

  async updateEvent(eventId, eventData) {
    return apiClient(`/calendar/${eventId}`, {
      method: "PUT",
      body: eventData
    });
  },

  async deleteEvent(eventId) {
    return apiClient(`/calendar/${eventId}`, {
      method: "DELETE"
    });
  },

  async modifyInstance(data) {
    return apiClient("/calendar/instance/modify", {
      method: "POST",
      body: data
    });
  },

  async cancelInstance(data) {
    return apiClient("/calendar/instance/cancel", {
      method: "POST",
      body: data
    });
  }
};